<template>
  <ul class="home-buttons">
    <li v-for="(button, i) of buttons" :key="`button-${i}`">
      <router-link :to="button.route"
                   :class="getClassNames(button)"
                   :disabled="button.disabled">
        <div class="background" :style="getCSS(button)"></div>
        <div class="label">
          <span v-text="button.label"/>
        </div>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true }
  },

  setup(props) {
    const buttons = props.items.map(item => ({
      variant: 'outline-primary',
      label: '',
      action: 'unknown',
      size: 'lg',
      disabled: false,
      image: null,
      route: { name: 'MainActivity' },
      ...item,
    }))

    const getClassNames = button => {
      const res = []
      if (button.disabled) {
        res.push('disabled')
      }
      return res
    }

    const getCSS = button => {
      const res = {}
      if (button.image) {
        const image = require(`@/app/assets/img/${button.image}`)
        res.backgroundImage = `url(${image})`
      }
      return res
    }

    return {
      buttons,
      getClassNames,
      getCSS,
    }
  }
}
</script>

<style lang="scss">
ul.home-buttons {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  height: var(--activity-height);

  li {
    display: flex;
    flex-direction: column;
    justify-content: center;

    a {
      height: calc(100% - 20px);
      width: calc(100% - 20px);
      align-self: center;
      position: relative;
      overflow: hidden;
      border: 1px solid #c7c7c7;
      box-shadow: 0 0 7px #b3b3b3;

      & > * {
        position: absolute;
        left: 0;
        width: 100%;
      }

      .background {
        top: 0;
        height: 100%;
        transition: all .5s;
        background-size: cover;
        background-position: center center;
      }

      .label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        bottom: 0;
        height: 60px;
        color: #000;
        font-size: 1.3em;
        z-index: 1;

        &:before {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #fff;
          opacity: .85;
          z-index: -1;
        }
      }

      &:hover {
        .background {
          transform: scale(1.05);
        }
      }

      &.disabled {
        opacity: .3;
        pointer-events: none;
      }
    }
  }

  @media screen and (max-width: 470px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);

    .btn {
      height: calc(100% - 20px);
    }
  }
}
</style>
